export default[
    {
        path:'/my',
        name:'name',
        component: () => import('@/views/my/my'),
        children:[
            {
                name:'my',
                path:'/my/my',
                component:() => import('@/views/my/myChild/my')
            },
            // 账户管理
            {
                name:'set_changePassword',
                path:'/my/set_changePassword',
                component:() => import('@/views/my/myChild/set_changePassword')
            },{
                name:'set_chanpin',
                path:'/my/set_chanpin',
                component:() => import('@/views/my/myChild/set_chanpin')
            },{
                name:'set_gongsi',
                path:'/my/set_gongsi',
                component:() => import('@/views/my/myChild/set_gongsi')
            },{
                name:'set_info',
                path:'/my/set_info',
                component:() => import('@/views/my/myChild/set_info')
            },
            // 喜欢
            {
                name:'sc_books',
                path:'/my/sc_books',
                component:() => import('@/views/my/myChild/sc_books')
            },{
                name:'sc_fabu',
                path:'/my/sc_fabu',
                component:() => import('@/views/my/myChild/sc_fabu')
            },{
                name:'sc_kuanshi',
                path:'/my/sc_kuanshi',
                component:() => import('@/views/my/myChild/sc_kuanshi')
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/my.js